module.exports = __webpack_public_path__ + "img/more.2063c35f.svg";